import { useSearchParams } from 'react-router-dom';
import classNames from 'classnames';
import styles from './index.module.scss'
import { useEffect, useState } from 'react';
import { news_detail } from '@/apis/news'
import { blog_detail } from "@/apis/blog"
import { event_detail } from "@/apis/event"
import intl from 'react-intl-universal';

// const des = "<a href='www.baidu.com'>我是一个a标签</a>"

const Detail = () => {
	let [searchParams] = useSearchParams();
	const id = searchParams.get('id');
	const type = searchParams.get('type');
	const [info, setInfo] = useState({
		content: []
	});

	// const changeA=()=>{
	// 	let a = document.createElement('a')
	// 	a.href='www.baidu.com'
	// 	a.innerHTML="我是一个a标签"
	// 	return a
	// }

	const getDetail = () => {
		if (type === "NEWS") {
			news_detail({ newsUuid: id }).then(res => {
				const item = res.data || {}
				setInfo({
					type: item?.newsType,
					title: item?.title,
					author: item?.author,
					date: item?.phenomenonTime,
					des: item?.text,
					imgPath: item?.image?.filePath,
					imgName: item?.imageName,
					content: item?.newsContents || []
				})
			}).catch(err => { })
		} else if (type === "BLOG") {
			blog_detail({ blogUuid: id }).then(res => {
				const item = res.data || {}
				setInfo({
					type: item?.blogType,
					title: item?.title,
					author: item?.author,
					date: item?.createTime,
					des: item?.text,
					imgPath: item?.image?.filePath,// 主图
					imgName: item?.imageName,// 主图路径
					content: item?.blogContents || []
				})
			}).catch(err => { })
		} else if (type === "EVENTS") {
			event_detail({ eventsUuid: id }).then(res => {
				const item = res.data || {}
				setInfo({
					type: item?.eventsType,
					title: item?.title,
					author: item?.author,
					date: item?.phenomenonTime,
					des: item?.text,
					imgPath: item?.image?.filePath,
					imgName: item?.imageName,
					content: item?.eventsContents || []
				})
			}).catch(err => { })
		}
	}
	useEffect(() => {
		if (id && type) {
			getDetail()
		}
	}, [id, type])
	return <div className={classNames("container", styles.detailBox)}>
		<span>{intl.get(`community.${type}`)} / {info.type}</span>
		<div className={styles.titleBox}>{info.title}</div>
		<div className={styles.dateBox}>
			{intl.get("Posted on")} {info.date}
			{info.author && <span>{intl.get("Author")}：{info.author}</span>}
		</div>
		{/*type === "BLOG" && <div className={styles.authorBox}>This blog post is written by <span>{info.author}</span></div>*/}
		<p className={styles.des} dangerouslySetInnerHTML={{ __html: info.des }} />
		{info.imgPath && <div  className={classNames(styles.imgBox,"flex_box","align_center","flex_direction")}>
			<img src={process.env.REACT_APP_API_AFFIX+"/file/preview?filePath=" + info.imgPath} />
			<p>{info.imgName}</p>
		</div>
		}
		{
			info.content.map((item, index) =>
				<div key={index + '_detail' + type} className={styles.contentBox}>
					<h1>{item.title}</h1>
					{
						item.paragraphs.map((son, sonIndex) => {
							return <div key={index + "_" + sonIndex + type}>
								<div dangerouslySetInnerHTML={{ __html: son.text }} />
								{son.image && <div className={classNames(styles.imgBox,"flex_box","align_center","flex_direction")}>
									<img src={process.env.REACT_APP_API_AFFIX+"/file/preview?filePath=" + son.image.filePath} />
									<p>{son.imageName}</p>
								</div>
								}
							</div>
						})
					}
				</div>
			)
		}
	</div>
}
export default Detail;